import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { DirectionsRenderer } from '@react-google-maps/api';
import { useRoutes } from '../../hooks';
import SitesInMarkers from './SitesInMarkers';

const DirectionsSegments = ({ directions, shouldSuppressMarkers = false }) => {
  // Hook useRoute to have access to RoutesContext
  const { currentRoute } = useRoutes();
  const panelRef = useRef(null);
  const [divElement, setDivElement] = useState(null);

  useEffect(() => {
    setDivElement(panelRef.current);

    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      img.adp-marker2 {
        max-width: none !important;
        padding: 2px !important;
      }
    `;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const generateSVGMarker = (label, color) => {
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40">
        <path fill="${color}" d="M16 0C7.2 0 0 7.2 0 16c0 11.2 16 24 16 24s16-12.8 16-24c0-8.8-7.2-16-16-16z"/>
        <text x="16" y="22" text-anchor="middle" font-size="16" fill="white" font-family="Arial" dy=".3em">${label}</text>
      </svg>
    `)}`;
  };

  const removeTextNodes = (element) => {
    // This function removes text nodes inside the element but keeps child divs and other elements.
    const childNodes = Array.from(element.childNodes);
    childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        element.removeChild(node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        removeTextNodes(node);
      }
    });
  };

  useEffect(() => {
    if (divElement) {
      removeTextNodes(divElement);
    }
  }, [divElement]);

  return (
    <div id="panel" ref={panelRef} className="flex">
      {!shouldSuppressMarkers && (
        <SitesInMarkers sitesArray={currentRoute.stops} shouldContainDirections />
      )}
      {!!divElement && (
        <DirectionsRenderer
          directions={directions}
          options={{ suppressMarkers: true }}
          panel={divElement}
          onLoad={(data) => {
            const callback = (mutationList) => {
              mutationList.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                  const allMarkers = mutation.addedNodes[0].querySelectorAll('[class^="adp-marker"]');

                  if (currentRoute.stops.length === allMarkers.length) {
                    currentRoute.stops.forEach((route, index) => {
                      const label = (index + 1).toString();
                      const color = '#FE6256';
                      allMarkers[index].src = generateSVGMarker(label, color);
                    });
                  }
                }
              });
            };

            const observer = new MutationObserver(callback);
            const config = { childList: true };
            observer.observe(data.panel, config);
          }}
        />
      )}
    </div>
  );
};

DirectionsSegments.propTypes = {
  directions: PropTypes.object,
  shouldSuppressMarkers: PropTypes.bool,
};

export default DirectionsSegments;
